export default __webpack_public_path__ + "static/media/png-fundo.39f53e74.png";